/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Error } from "../models";

@Injectable({
  providedIn: "root"
})
export class NotificationService {
  constructor(private toastr: ToastrService) {}

  error(error: Error) {
    if (error.error instanceof Array) {
      error.error.forEach((innerError) => {
        this.toastr.error(NotificationService.getErrorMessageFromErrorArray(error, innerError), "An Error Occurred");
      });
    } else {
      this.toastr.error(NotificationService.getErrorMessageFromErrorObject(error), "An Error Occurred");
    }
  }

  private static buildBaseMessage(errorObject: Error) {
    let baseMessage = "";

    if (errorObject.status) {
      baseMessage += "Code: " + errorObject.status + "<br>";
    }
    if (errorObject.message) {
      baseMessage += "Message: " + errorObject.message + "<br>";
    }
    return baseMessage;
  }

  private static getErrorMessageFromErrorObject(errorObject: Error) {
    // detail can contain very long stack trace from BE so shorten it
    let message = NotificationService.buildBaseMessage(errorObject);
    if (errorObject.error) {
      message += "Details: " + errorObject.error.substr(0, 200);
      if (errorObject.error.length > 200) {
        message += "... [see server log for more details]";
      }
    }
    return message;
  }

  private static getErrorMessageFromErrorArray(errorObject: Error, arrayError: any) {
    // detail can contain very long stack trace from BE so shorten it
    let message = NotificationService.buildBaseMessage(errorObject);
    if (arrayError.errorMessage) {
      message += "Details: " + arrayError.errorMessage.substr(0, 200);
      if (arrayError.errorMessage.length > 200) {
        message += "... [see server log for more details]";
      }
    }
    return message;
  }
}
